import { Component, Input } from '@angular/core';
import { MonthYearFilter } from './month-year-filter.model';

@Component({
  selector: 'ap-month-year-filter-item',
  templateUrl: './month-year-filter-item.component.html'
})
export class MonthYearFilterItemComponent {

  @Input() filter: MonthYearFilter;

  constructor() { }

}
